import { Separator as BaseSeparator } from '@base-ui/react/separator';
import type * as React from 'react';
import { cn } from '@/lib/utils';

export function Separator({
  className,
  orientation = 'horizontal',
  ...props
}: React.ComponentProps<typeof BaseSeparator> & { orientation?: 'horizontal' | 'vertical' }) {
  return (
    <BaseSeparator
      className={cn('bg-mesa-border shrink-0', orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px', className)}
      {...props}
    />
  );
}
